// AttachmentsPanel chrome — EN + TR.
import type { LocalizedDict } from '../index'

type AttachmentsStrings = {
  title: string
  upload: string
  uploading: string
  uploadFailed: string
  loading: string
  empty: string
  delete: string
}

export const attachmentsI18n: LocalizedDict<AttachmentsStrings> = {
  en: {
    title: 'Attachments',
    upload: 'Upload',
    uploading: 'Uploading…',
    uploadFailed: 'Upload failed',
    loading: 'Loading…',
    empty: 'No files yet. Upload one to attach it here.',
    delete: 'Delete attachment',
  },
  tr: {
    title: 'Ekler',
    upload: 'Yükle',
    uploading: 'Yükleniyor…',
    uploadFailed: 'Yükleme başarısız',
    loading: 'Yükleniyor…',
    empty: 'Henüz dosya yok. Buraya eklemek için bir dosya yükleyin.',
    delete: 'Eki sil',
  },
}
